import React, { useEffect, memo } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'ramda';
import {
  Container,
  FiltersBarSticky,
  LoadMoreButtonContainer,
  FilteredExperiences,
  NoResults,
} from './filtered.styles';
import { Page } from '../../shared/components/page';
import { Theme } from '../../modules/headerBar/themes';
import messages from '../market/market.messages';
import { useLazyLoading } from '../../shared/hooks/useLazyLoading';
import { LoadMoreButton } from '../market/loadMoreButton';
import { renderWhenTrue, renderWhenTrueOtherwise } from '../../shared/utils/rendering';
import { Helmet } from '../../shared/components/helmet';

const FilteredComponent = props => {
  const {
    intl,
    experiences,
    filters,
    startListeningQueryUpdate,
    stopListeningQueryUpdate,
    isListenerActive,
    isFetching,
    isFetchingAllMarkets,
    pageTitle,
    logFilteredViewedExperiences,
  } = props;
  const [{ visibleItems, allItemsVisible, threshold, lastItemIndex }, loadMore] = useLazyLoading(experiences);

  const onLoadMore = () => {
    logFilteredViewedExperiences(lastItemIndex, lastItemIndex + threshold);
    loadMore();
  };

  useEffect(() => {
    if (!isListenerActive) {
      startListeningQueryUpdate(threshold);
    }

    return function cleanup() {
      return stopListeningQueryUpdate();
    };
    //eslint-disable-next-line
  }, []);

  const renderLoadMore = () => (
    <LoadMoreButtonContainer>
      <LoadMoreButton onClick={onLoadMore} label={intl.formatMessage(messages.seeMoreExperiences)} />
    </LoadMoreButtonContainer>
  );

  const renderNoResultsPage = () => (
    <NoResults titleMessage={messages.noResultsTitle} descriptionMessage={messages.noResultsDescription} />
  );

  const renderMarketExperience = () => (
    <FilteredExperiences
      placeholder={isFetching || isFetchingAllMarkets}
      experiences={visibleItems}
      title={intl.formatMessage(messages.counter, { count: experiences.length })}
    />
  );

  return (
    <Page headerTheme={Theme.FILLED}>
      <Helmet noTitle={isEmpty(pageTitle)} title={pageTitle} />
      <Container>
        <FiltersBarSticky availableFilters={filters} />
        {renderWhenTrueOtherwise(renderNoResultsPage, renderMarketExperience)(
          !(isFetching || isFetchingAllMarkets) && !visibleItems.length
        )}
        {renderWhenTrue(renderLoadMore)(!allItemsVisible)}
      </Container>
    </Page>
  );
};

FilteredComponent.propTypes = {
  isFetchingAllMarkets: PropTypes.bool.isRequired,
  isFetching: PropTypes.bool.isRequired,
  isListenerActive: PropTypes.bool.isRequired,
  startListeningQueryUpdate: PropTypes.func.isRequired,
  stopListeningQueryUpdate: PropTypes.func.isRequired,
  filters: PropTypes.arrayOf(PropTypes.object).isRequired,
  intl: PropTypes.object.isRequired,
  experiences: PropTypes.arrayOf(PropTypes.object),
  pageTitle: PropTypes.string.isRequired,
  logFilteredViewedExperiences: PropTypes.func.isRequired,
};

export const Filtered = memo(FilteredComponent);
